import { OrganizationEngagement } from '../api/controllers/engagementAnalyticsReporting';

export interface EngagementsPagedResult {
    engagements: OrganizationEngagement[];
    complete: boolean;
    reachedCap: boolean;
}

export const loadEngagementsPagedResult = async (
    loadFn: (id: string, filter: any) => Promise<any>,
    id: string,
    filter: { startDate: string; endDate: string; timezone?: string },
    pageSize: number = 5000,
    maxRecords: number = 200000,
    logCallback?: (message: string) => void
): Promise<EngagementsPagedResult> => {
    const allEngagements: OrganizationEngagement[] = [];
    let skip = 0;
    let hasMore = true;
    let complete = false;

    while (hasMore && allEngagements.length < maxRecords) {
        const requestedPageSize = Math.min(pageSize, maxRecords - allEngagements.length);
        const pagedFilter = {
            ...filter,
            skip,
            take: requestedPageSize
        };

        if (logCallback) {
            logCallback(`Loading engagements... (${allEngagements.length} loaded so far)`);
        }

        const result = await loadFn(id, pagedFilter);
        if (!result || result.resultType !== 'Ok') {
            throw new Error(result?.errors?.[0] ?? 'Failed to load engagements page');
        }
        const batch = (result.data || []).slice(0, requestedPageSize);

        allEngagements.push(...batch);
        skip += batch.length;
        hasMore = batch.length === requestedPageSize;
        complete = !hasMore;
    }

    const reachedCap = hasMore && allEngagements.length >= maxRecords;

    if (logCallback) {
        logCallback(`Loaded ${allEngagements.length} engagements total`);
    }

    return { engagements: allEngagements, complete, reachedCap };
};
